export function calcXp(correct, total) {
  const base = correct * 10;
  const bonus = total === correct ? 20 : 0; // perfect score bonus
  return base + bonus;
}

export const BADGE_RULES = [
  { id: 'rookie',  xp: 100 },
  { id: 'pro',     xp: 500 },
  { id: 'legend',  xp: 2000 }
]; 